import { AdminLabOrderPrintLogLabOrderList, CaseAdmin } from "pwapi";

enum PriorityWeight {
  "stat" = 3,
  "rush" = 2,
  "normal" = 1,
}

// In place sort to ensure created_at orders for subsequent organization
export const sortOrders = (labOrders?: AdminLabOrderPrintLogLabOrderList[]) =>
  labOrders
    ?.filter((order) => order.created_at)
    .sort((a, b) => (a.created_at! > b.created_at! ? 1 : -1));

// Sorts cases by their priority, returning a list of accessions
export const sortCases = (
  cases: {
    [key: string]: {
      [key: string]: AdminLabOrderPrintLogLabOrderList[];
    };
  },
  ordersByCase: { [key: string]: AdminLabOrderPrintLogLabOrderList[] }
) =>
  Object.keys(cases).sort((accessionA, accessionB) => {
    const orderA = ordersByCase[accessionA][0];
    const orderB = ordersByCase[accessionB][0];
    const priorityA =
      PriorityWeight[orderA.case_priority as keyof typeof PriorityWeight];
    const priorityB =
      PriorityWeight[orderB.case_priority as keyof typeof PriorityWeight];

    // If the priority weight is the same, additional properties need to be checked
    if (priorityA === priorityB) {
      // For normal priority, clinic priority comes first
      if (
        orderA.case_priority === CaseAdmin.priority.NORMAL &&
        orderA.clinic_tat !== orderB.clinic_tat
      ) {
        return orderA.clinic_tat ? -1 : 1;
      }

      // Finally if all else is the same, the created_at date is the final sort
      return orderA.created_at! > orderB.created_at! ? 1 : -1;
    } else {
      // If the priority weights are not the same, the higher priority comes first
      return priorityA > priorityB ? -1 : 1;
    }
  });

export const getPriorityLabel = (order?: AdminLabOrderPrintLogLabOrderList) => {
  if (!order) return null;
  if (order.case_priority !== CaseAdmin.priority.NORMAL) {
    return order.case_priority?.toUpperCase();
  } else {
    return order.clinic_tat ? "PRIORITY" : null;
  }
};
